import React, { useState, useMemo } from 'react'
import { getElementDisplayName } from '../../utils/getElementDisplayName'
import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'
import { Input } from 'alurkerja-ui'
import { useUiFromSpecContext } from '../../../EditorContextProvider'
import { UseFormReturn } from 'react-hook-form'
import { validateFormula } from './utils/validateFormula'

type EditDefaultInputProps = {
  index: number
  element: string
  form: UseFormReturn<any>
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

export default function EditFormula(props: EditDefaultInputProps) {
  const { setDisableSaveEdit, selectedElement } = useUiFromSpecContext()
  const { index, element, currentElementState, setCurrentElementState, form } = props
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const nameFields = useMemo(() => {
    return Object.entries(form.watch())
      .map(([key, _]) => key)
      .filter((key) => key !== selectedElement?.name)
  }, [form])

  return (
    <div key={index} className="p-3 py-2 rounded-sm ">
      <span className="font-semibold">{stringToTitleCase(getElementDisplayName(element))}</span>
      <Input
        className="w-full"
        type="text"
        size="sm"
        rounded="lg"
        value={currentElementState[element]}
        onChange={(e) => {
          const newValue = e.target.value
          const error = validateFormula(newValue, nameFields)
          setDisableSaveEdit?.(Boolean(error))
          setErrorMessage(error)

          setCurrentElementState((prevState: any) => {
            return {
              ...prevState,
              [element]: newValue,
            }
          })
        }}
      />
      {errorMessage && (
        <div className="mt-1 text-xs text-red-500">
          <span className="flex items-center">{errorMessage}</span>
        </div>
      )}
    </div>
  )
}
